<template>
    <div style="margin-bottom: 20px;">

        <div class="row">
            <div class="col-sm-12" v-for="(com, index) in comentarios" :key="index">
                <div class="card border-info mb-3" style="margin-top: 20px;">
                    <div class="card-body">
                        <!--<p class="card-text">{{com.Comentario}}</p>-->
                        <p class="card-text" v-html="com.Comentario">
                            <p class="font-italic">{{com.Autor}}, {{com.Institution}}.
                        </p>
                        <div class="card-body text-white border-dark bg-secondary mb-3" v-if="com.Respuesta != null && com.Respuesta !=''">
                            <p class="card-text">Respuesta de Difraco: {{com.Respuesta}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <b-button v-b-modal.modal variant="primary" @click="addClick()">Agregar un comentario</b-button>

            <b-modal id="modal" title="Agregar un comentario" hide-footer hide-header centered>

                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{modalTitle}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal')">
                    </button>
                </div>

                <div style="margin-bottom: 20px;">
                    Todos los campos son obligatorios.
                </div>

                <div>
                    
                        <p>
                            <span class="input-group-text">Autor</span> <input type="text" class="form-control" v-model="Autor">
                        
                            &nbsp;
                        
                            <span class="input-group-text">Email</span> <input type="text" class="form-control" v-model="Email">
                        
                            &nbsp;
                        
                            <span class="input-group-text">Institución</span> <input type="text" class="form-control" v-model="Institution">
                        
                            &nbsp;
                        
                            <span class="input-group-text">Comentario</span>
                            <textarea class="form-control" v-model="Comentario" aria-label="Comentario"></textarea>
                        </p>
                </div>
                &nbsp;
                <div>
                    <button type="button" @click="createClick()"
                    v-if="ComentarioID==0" class="btn btn-primary">
                    Agregar
                    </button>
                </div>
            </b-modal>
        </div>
        
        <!--
        <button type="button"
        class="btn btn-primary m-2 fload-end"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        @click="addClick()">
        Agregar un comentario
        </button>

        <div class="modal fade" id="exampleModal" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{modalTitle}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>

            <div class="modal-body">

                <div>
                    
                        <p>
                            <span class="input-group-text">Autor</span> <input type="text" class="form-control" v-model="Autor">
                        
                            &nbsp;
                        
                            <span class="input-group-text">Email</span> <input type="text" class="form-control" v-model="Email">
                        
                            &nbsp;
                        
                            <span class="input-group-text">Institución</span> <input type="text" class="form-control" v-model="Institution">
                        
                            &nbsp;
                        
                            <span class="input-group-text">Comentario</span>
                            <textarea class="form-control" v-model="Comentario" aria-label="Comentario"></textarea>
                        </p>
                </div>
                &nbsp;
                <div>
                    <button type="button" @click="createClick()"
                    v-if="ComentarioID==0" class="btn btn-primary">
                    Agregar
                    </button>
                </div>
            </div>

        </div>
        </div>
        </div>
        -->

    </div>
</template>

<script>
import axios from 'axios';

export default {

    data(){

    return{
        comentarios:[],
        modalTitle:"",
        Comentario:"",
        ComentarioID:0,
        //Respuesta:"",
        Autor:"",
        Email:"",
        Institution:""
    }
    },

    methods:{
    refreshData(){
        axios.get("http://difraco.com.co:8000/blog")
        .then((response)=>{
            this.comentarios=response.data;
            this.comentariosWithoutFilter=response.data;
        })
    },

    addClick(){
        this.modalTitle="Agregar un comentario";
        this.ComentarioID=0;
        this.Comentario="";
        //this.Respuesta="";
        this.Autor="";
        this.Email="";
        this.Institution=""
    },

    createClick(){
        axios.post("http://difraco.com.co:8000/blog",{
            Comentario:this.Comentario,
            //Respuesta:this.Respuesta,
            Autor:this.Autor,
            Email:this.Email,
            Institution:this.Institution
        })
        .then((response)=>{
            this.refreshData();
            alert(response.data);
        });
    },
},

mounted:function(){
    this.refreshData();
}

};

</script>
